import { ResourceDescriptor } from "./common";

const user_email: ResourceDescriptor = {
    url: "user_email",
    orders: {
        create: ["address"],
    },
    identifiers: ["address"],
    expand: {},
    resourceSchemaPostProcessor: (schema) => {
        delete schema["tokens"];
        delete schema["verified_at"];
    },
};

export default user_email;
